import React from "react";
import { array, object } from "prop-types";
import { ClientSideOnly, ResponsiveImage } from "@quintype/components";
import AuthorImg from "../other-icons/AuthorImg";

import "./author.m.css";

const AuthorAvatar = ({ author }) => {
  const name = author.name;
  const avatarURL = author["avatar-s3-key"];
  const authorAvatarUrl = author["avatar-url"];
  let imageView = null;

  if (avatarURL) {
    imageView = (
      <ResponsiveImage
        styleName="author-img"
        slug={avatarURL}
        aspectRatio={[1, 1]}
        alt={name.substring(1)}
        widths={[50]}
        type="image/webp"
        imgParams={{ auto: ["format", "compress"], fit: "max", q: 70 }}
      />
    );
  } else if (authorAvatarUrl) {
    imageView = <img styleName="author-img" src={authorAvatarUrl} alt={name.substring(1)} />;
  } else {
    imageView = (
      <div styleName="default-author-img">
        <AuthorImg />
      </div>
    );
  }

  return <ClientSideOnly>{imageView}</ClientSideOnly>;
};

AuthorAvatar.propTypes = {
  author: object
};

const Author = ({ authors, story }) => {
  const bylineAuthorName = story?.metadata?.["byline-no-author-page"];

  return (
    <div styleName="authors-wrapper">
      {bylineAuthorName && bylineAuthorName.length > 0 ? (
        <div styleName="author-wrapper">
          <div styleName="author-avatar">
            <div styleName="default-author-img">
              <AuthorImg />
            </div>
          </div>
          <div styleName="author-name">
            <span>{bylineAuthorName}</span>
          </div>
        </div>
      ) : (
        <>
          {authors &&
            authors.map((author, index) => (
              <div key={index} styleName="author-wrapper">
                <div styleName="author-avatar">
                  <AuthorAvatar author={author} />
                </div>
                <div styleName="author-name">
                  <a href={`/author/${author.slug}`}>{author.name}</a>
                </div>
              </div>
            ))}
        </>
      )}
    </div>
  );
};

Author.propTypes = {
  authors: array
};

export default Author;
